const FORMATTING_LOCALE_STORAGE_KEY = 'userFormattingLocale'

export const getBrowserFormattingLocale = () => {
  if (typeof navigator === 'undefined') return 'en-GB'

  const browserLang = (navigator.languages?.[0] || navigator.language || '').toLowerCase()
  if (browserLang.startsWith('nl')) return 'nl-NL'
  if (browserLang.startsWith('de')) return 'de-DE'
  return 'en-GB'
}

export const getFormattingLocalePreference = (fallback = 'en-GB') => {
  if (typeof window === 'undefined') return fallback
  return (
    localStorage.getItem(FORMATTING_LOCALE_STORAGE_KEY) || getBrowserFormattingLocale() || fallback
  )
}

export const setFormattingLocalePreference = (locale?: string) => {
  if (typeof window === 'undefined') return

  if (locale) localStorage.setItem(FORMATTING_LOCALE_STORAGE_KEY, locale)
  else localStorage.removeItem(FORMATTING_LOCALE_STORAGE_KEY)
}
